import { useEffect, useState } from 'react';
import {
    asyncGetOrbitCatalog,
    asyncGetOrbitCitiesFlat,
} from '../../../../services/orbit.service';
import { OrbitCatalogEnum } from '../../../../shared/types/orbit';

const REQUIRED_RADICATION_CATALOGS = [
    OrbitCatalogEnum.CaseTypes,
    OrbitCatalogEnum.Departments,
    OrbitCatalogEnum.Countries,
] as const;

export const useOrbitRadicationCatalogs = (enabled: boolean) => {
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (!enabled) {
            setLoading(false);
            setError(undefined);
            return;
        }

        let active = true;
        setLoading(true);
        setError(undefined);

        const load = async () => {
            const catalogResults = await Promise.all(
                REQUIRED_RADICATION_CATALOGS.map((catalog) =>
                    asyncGetOrbitCatalog(catalog)
                )
            );

            const failedCatalogIndex = catalogResults.findIndex(
                (result) => result.error || result.items.length === 0
            );
            const catalogError =
                failedCatalogIndex >= 0
                    ? catalogResults[failedCatalogIndex].error ||
                      `No se pudieron cargar las opciones de Orbit (${REQUIRED_RADICATION_CATALOGS[failedCatalogIndex]}).`
                    : undefined;

            if (!active) return;

            if (catalogError) {
                setError(catalogError);
                setLoading(false);
                return;
            }

            const citiesResult = await asyncGetOrbitCitiesFlat();

            if (!active) return;

            if (citiesResult.error) {
                setError(citiesResult.error);
            }

            setLoading(false);
        };

        load();

        return () => {
            active = false;
        };
    }, [enabled]);

    return { loading, error };
};
